body.sliding-panel-open {
  overflow: hidden !important;
}

.sliding-panel {
  .sliding-panel-container {
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
  }

  .sliding-panel-container.active {
    position: fixed;
    z-index: 15000;
    background-color: rgba(0, 0, 0, 0.3);
    will-change: transform;
  }

  .sliding-panel-container.active.click-through {
    pointer-events: none;
    background-color: transparent;
  }

  .sliding-panel-container.click-through > div {
    pointer-events: none;
  }

  .panel {
    position: relative;
    overflow: hidden;
    background: #fff;
  }

  .panel-header {
    position: static;
    padding: 0.5rem 2rem 0.25rem 2rem;
    background: #fff;
    overflow: none;
    border-bottom: 1px solid var(--sbb-color-cloud);
    display: flex;
    z-index: 10000;

    h1 {
      margin: 0.75em 0 0 0;
      padding: 0;
      line-height: 1;
    }
  }

  .panel-content {
    height: 100%;
    height: calc(100vh - 10rem);
    pointer-events: all;
    position: relative;
    overflow-y: scroll;
  }

  .panel-footer {
    border-top: 1px solid var(--sbb-color-cloud);
    position: static;
    bottom: 0;
    height: 5rem;
    padding: 2rem;
    background: #fff;
    overflow: hidden;
  }

  .panel-container-left-enter {
    opacity: 0;
    transform: translateX(-100%);
  }

  .panel-container-left-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-left-exit {
    opacity: 1;
    transform: translateX(0);
  }

  .panel-container-left-exit-active {
    opacity: 0;
    transform: translateX(-100%);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-right-enter {
    opacity: 0;
    transform: translateX(100%);
  }

  .panel-container-right-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-right-exit {
    opacity: 1;
    transform: translateX(0);
  }

  .panel-container-right-exit-active {
    opacity: 0;
    transform: translateX(100%);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-top-enter {
    opacity: 0;
    transform: translateY(-100%);
  }

  .panel-container-top-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-top-exit {
    opacity: 1;
    transform: translateX(0);
  }

  .panel-container-top-exit-active {
    opacity: 0;
    transform: translateY(-100%);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-bottom-enter {
    opacity: 0;
    transform: translateY(100%);
  }

  .panel-container-bottom-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container-bottom-exit {
    opacity: 1;
    transform: translateX(0);
  }

  .panel-container-bottom-exit-active {
    opacity: 0;
    transform: translateY(100%);
    transition:
      transform 500ms,
      opacity 500ms;
  }

  .panel-container {
    height: 100%;
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 2rem;
    position: relative;
  }

  .panel {
    background-color: #fff;
  }

  .panel-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    padding: 1.5rem 0 0 0;
    margin: 2rem 0 0 0;
    flex-wrap: nowrap;
    border-top: 1px solid var(--sbb-color-cloud);
  }

  .save-button,
  .cancel-button {
    margin: 0 0.5rem;
  }
}

.debug-content {
  border-top: 1px dashed #999;
  padding-top: 0.25rem;
  font-family: var(--bs-font-monospace) !important;
  white-space: pre-wrap;
  font-size: 10px;
  display: none;
}

.sbb-environment-local .debug-content,
.sbb-environment-dev .debug-content {
  display: block;
}

.panel-subtitle {
  margin: 2rem 0 1rem 0;
  padding: 0;
  width: 100%;
  font-size: 15px;
  text-decoration: underline;
  text-underline-offset: 5px;
}
